/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The result from Synop start transaction with applicable status.
 */
export var CommunicationResult;
(function (CommunicationResult) {
    CommunicationResult["APPLIED"] = "Applied";
    CommunicationResult["PENDING"] = "Pending";
    CommunicationResult["REJECTED"] = "Rejected";
    CommunicationResult["NOT_SUPPORTED"] = "NotSupported";
    CommunicationResult["UNKNOWN"] = "Unknown";
    CommunicationResult["TIMEOUT"] = "Timeout";
    CommunicationResult["NOT_CONNECTED"] = "NotConnected";
    CommunicationResult["INVALID"] = "Invalid";
})(CommunicationResult || (CommunicationResult = {}));
